import styled from 'styled-components';
import { rem } from 'polished';

const WrapperError = styled.div`
  background-color: ${props => props.theme.colors.grayLightest};
  padding: ${rem('100px')} 1rem;
  text-align: center;
  margin-bottom: 2rem;
`;

const ParagraphError = styled.p`
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${rem('16px')};
  margin: ${rem('20px')} 0 ${rem('10px')} 0;
  text-transform: uppercase;
`;

const ParagraphSearch = ParagraphError.extend`
  font-size: ${rem('18px')};
  margin-top: 0;
  text-transform: none;
`;
const Paragraph = ParagraphSearch.extend`
  font-size: ${rem('16px')};
  margin: 5rem 0 0 0;
`;
const ParagraphSmall = Paragraph.extend`
  margin-top: 0;
  font-size: ${rem('14px')};
`;

const LinkParagraph = styled.a`
  font-family: inherit;
`;

export {
  WrapperError,
  ParagraphError,
  ParagraphSearch,
  Paragraph,
  ParagraphSmall,
  LinkParagraph
};
